class PortfolioSrv {

	constructor ($resource, SERVICE_URL_CONSTANT) {
		// PORTFOLIO SERVICES
		var getPortfolioBasics = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getPortfolioBasics', {}, {
			get: {
				method: 'POST',
			},
		})

		var getStatements = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getStatements', {}, {
			get: {
				method: 'POST',
			},
		})
    
		var getPortfolioComitee = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getPortfolioComitee', {}, {
			get: {
				method: 'POST',
			},
		})
    
		var getEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getEvalComment', {}, {
			get: {
				method: 'POST',
			},
		})

		var getCommentsUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getCommentsUsers', {}, {
			get: {
				method: 'POST',
			},
		})

		var getCommentsEvals = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getCommentsEvals', {}, {
			get: {
				method: 'POST',
			},
		})

		var getReflectionCommentById = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getReflectionCommentById', {}, {
			get: {
				method: 'POST',
			},
		})    

		var getEvidences = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getEvidences', {}, {
			get: {
				method: 'POST',
			},
		})  

		var getReflections = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getReflections', {}, {
			get: {
				method: 'POST',
			},
		}) 

		var getBasicsRegistry = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getBasicsRegistry', {}, {
			get: {
				method: 'GET',
			},
		})    

		var getGuidelines = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getGuidelines', {}, {
			get: {
				method: 'GET',
			},
		})  

		var addGuideline = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addGuideline', {}, {
			add: {
				method: 'POST',
			},
		})

		var addUserComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addUserComment', {}, {
			add: {
				method: 'POST',
			},
		})

		var addEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addEvalComment', {}, {
			add: {
				method: 'POST',
			},
		})

		var addReflectionComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addReflectionComment', {}, {
			add: {
				method: 'POST',
			},
		})

		var addSharedUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addRelationSharedPortfolio', {}, {
			add: {
				method: 'POST',
			},
		})

		var addReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addReflection', {}, {
			add: {
				method: 'POST',
			},
		})

		var addEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addEvidence', {}, {
			add: {
				method: 'POST',
			},
		})

		var addStatement = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addStatement', {}, {
			add: {
				method: 'POST',
			},
		})

		var setInput = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/setInput', {}, {
			update: {
				method: 'POST',
			},
		})

		var setEnlighted = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/setEnlighted', {}, {
			update: {
				method: 'POST',
			},
		})

		var updateGuideline = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateGuideline', {}, {
			update: {
				method: 'POST',
			},
		})    
  
		var getSharedPortfolioUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getSharedPortfolioUsers', {}, {
			get: {
				method: 'POST',
			},
		})

		var getSharedPortfolio = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getSharedPortfolio', {}, {
			get: {
				method: 'POST',
			},
		})

		var getTeacherToEvaluation = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getTeacherToEvaluation', {}, {
			get: {
				method: 'POST',
			},
		})    

		var disableEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/disableEvidence', {}, {
			disable: {
				method: 'POST',
			},
		})

		var disableUserAccess = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/disableUserAccess', {}, {
			disable: {
				method: 'POST',
			},
		})

		var updateEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateEvidence', {}, {
			update: {
				method: 'POST',
			},
		})
    
		var updateEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateEvalComment', {}, {
			update: {
				method: 'POST',
			},
		})

		var updateReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateReflection', {}, {
			update: {
				method: 'POST',
			},
		})
	
		var deleteReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/deleteReflection', {}, {
			delete: {
				method: 'POST',
			},
		})

		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST',
			},
		})

		var getPerfilDash = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/perfil_dash/:teacherId', {}, {
			get: {
				method: 'GET',
			},
		})

		// SERVICES INJECTION
		return {
			getPortfolioBasics          : getPortfolioBasics,
			getBasicsRegistry           : getBasicsRegistry,
			getGuidelines               : getGuidelines,
			addGuideline                : addGuideline,
			addUserComment              : addUserComment,
			addReflectionComment        : addReflectionComment,
			setInput                    : setInput,
			setEnlighted                : setEnlighted,
			addReflection               : addReflection,
			addEvidence                 : addEvidence,
			getSharedPortfolioUsers     : getSharedPortfolioUsers,
			getSharedPortfolio          : getSharedPortfolio,
			disableEvidence             : disableEvidence,
			updateEvidence              : updateEvidence,
			getCommentsUsers            : getCommentsUsers,
			getReflectionCommentById    : getReflectionCommentById,
			getEvidences                : getEvidences,
			addStatement                : addStatement,
			getTeacherToEvaluation      : getTeacherToEvaluation,
			getPortfolioComitee         : getPortfolioComitee,
			getEvalComment              : getEvalComment,
			addEvalComment              : addEvalComment,
			updateEvalComment           : updateEvalComment,
			addSharedUsers              : addSharedUsers,
			disableUserAccess           : disableUserAccess,
			updateReflection            : updateReflection,
			deleteReflection            : deleteReflection,
			getReflections              : getReflections,
			getCommentsEvals            : getCommentsEvals,
			getStatements               : getStatements,
			updateGuideline             : updateGuideline,
			addNotificationsTransactions: addNotificationsTransactions,
			getPerfilDash               : getPerfilDash,
		}
	}

}
PortfolioSrv.$inject = [ '$resource', 'SERVICE_URL_CONSTANT' ]
export default angular.module('services.PortfolioSrv', []).service('PortfolioSrv', PortfolioSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/portfolioSrv.js